import React, { useRef, useEffect, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import theme from '../theme';

mapboxgl.accessToken = import.meta.env.VITE_MAP_BOX_KEY;

export const Map = (props) => {
    
    const { 
        center = {}, 
        markers, 
        zoom = 14,
        fitBounds = true
    } = props

    const mapContainer = useRef(null);
    const map = useRef(null);

    const { lat = -23.6274421233317, lng = -46.6992821 } = center

    useEffect(() => {
        if (map.current) return; // initialize map only once
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/streets-v11',
            center: [lng, lat],
            zoom: zoom
        });

        renderMarkers({ markers })
    });

    const renderMarkers = async ({ markers = [] }) => {

        var bounds = new mapboxgl.LngLatBounds();

        const markersGroup = await markers.map(marker => {

            /* markerType
            - default
            - point  */

            const { lat, lng, html, markerType } = marker

            const newMarker = new mapboxgl.Marker(markerType ? Point({ marker }) : { color: theme.palette.primary.main }).setLngLat([lng, lat])
            html && newMarker.setPopup(new mapboxgl.Popup().setHTML(html))

            bounds.extend([lng, lat]);
            newMarker.addTo(map.current);
            return newMarker
        })

        if(fitBounds){
            map.current.fitBounds(bounds, { padding: 50 })
        }

    }

    const Point = ({ marker }) => {

        const { number, markerType } = marker
        var point = document.createElement('div');
        if (number) {
            const numberText = document.createTextNode(number);
            point.appendChild(numberText)
        }
        if(markerType == "pointShopping"){
            point.style.backgroundColor = theme.palette.danger.main
        }else{
            point.style.backgroundColor = theme.palette.secondary.main
        }
        point.style.width = '20px'
        point.style.height = '20px'
        point.style.borderRadius = '12px'
        point.style.filter = 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))'
        point.style.textAlign = 'center';
        point.style.color = '#FFF'

        return point
    }

    return (
        <div style={{ height: 450, width: "100%", position: 'relative' }}>
            <div ref={mapContainer} style={{ height: '100%', width: '100%', position: 'absolute' }} />
        </div>
    )

}